import { useLayoutEffect, useState } from 'react';
import { useHeader } from '@screentone/core';

import { DEFAULT_PAGE_TITLE_HEIGHT, DEFAULT_SUBNAV_WRAPPER_HEIGHT } from 'utils/constants';

function useHeaderObserver() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const { containerHeight } = useHeader();
  const [pageTitleHeight, setPageTitleHeight] = useState(DEFAULT_PAGE_TITLE_HEIGHT);
  const [subnavHeight, setSubnavHeight] = useState(DEFAULT_SUBNAV_WRAPPER_HEIGHT);

  useLayoutEffect(() => {
    // Set CSS variables for header heights
    document.documentElement.style.setProperty('--app-header-height', `${containerHeight}px`);
    document.documentElement.style.setProperty('--app-page-title-height', `${pageTitleHeight}px`);
    document.documentElement.style.setProperty('--app-subnav-height', `${subnavHeight}px`);
    document.documentElement.style.setProperty(
      '--app-page-header-height',
      `${containerHeight + pageTitleHeight + subnavHeight}px`
    );
  }, [containerHeight, pageTitleHeight, subnavHeight]);

  useLayoutEffect(() => {
    const root = document.getElementById('root');

    if (!root) {
      return () => {};
    }

    let pageTitleEl: HTMLElement | null = null;
    let observer: ResizeObserver | null = null;

    const attachObserver = () => {
      const next = document.getElementById('widepage-wrapper-header') as HTMLElement;

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!next || pageTitleEl === next) return;

      pageTitleEl = next;

      observer?.disconnect();

      observer = new ResizeObserver(() => {
        const pageTitleHeight = pageTitleEl!.getBoundingClientRect().height;
        setPageTitleHeight(pageTitleHeight);

        let ucsSubnavHeaderHeight = DEFAULT_SUBNAV_WRAPPER_HEIGHT;
        const ucsSubnavHeader = document.getElementById('ucs-subnav-wrapper');

        if (ucsSubnavHeader) {
          ucsSubnavHeaderHeight = ucsSubnavHeader.getBoundingClientRect().height;
        }
        setSubnavHeight(ucsSubnavHeaderHeight);
      });

      observer.observe(pageTitleEl);
    };

    const mutationObserver = new MutationObserver(attachObserver);

    mutationObserver.observe(root, { childList: true, subtree: true });

    return () => {
      observer?.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
}

export default useHeaderObserver;
